var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"6","height":"26","viewBox":"0 0 6 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"3","cy":"3","r":"3","fill":"#277FAF"}}),_c('circle',{attrs:{"cx":"3","cy":"13","r":"3","fill":"#277FAF"}}),_c('circle',{attrs:{"cx":"3","cy":"23","r":"3","fill":"#277FAF"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }